export const CURB_LANE_WIDTH_VALUES = [
  '>12 ft',
  '>11 to 12 ft',
  '11 ft',
  '<11 ft'
]
export const CURB_LANE_WIDTH = 'curb_lane_width'
export const CURB_LANE_WIDTH_ADJUSTMENTS = 'curb_lane_width_adjustments'
export const SPECIAL_CONSIDERATIONS = 'special_considerations'
